import { createAction } from '@reduxjs/toolkit';

export const REMOVE_ORDER_PRODUCT = 'REMOVE_ORDER_PRODUCT';

export const removeOrderProduct = createAction(
    REMOVE_ORDER_PRODUCT,
    (id: number) => ({ payload: id }),
);
